"use strict";

var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _styles = require("@material-ui/core/styles");
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _excluded = ["classes", "fixedHeader", "fixedSelectColumn", "isHeaderCell", "expandableOn", "selectableOn", "isRowExpanded", "onExpand", "isRowSelectable", "selectableRowsHeader", "hideExpandButton", "expandableRowsHeader", "expandedRows", "areAllRowsExpanded", "selectableRowsHideCheckboxes"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultSelectCellStyles = function defaultSelectCellStyles(theme) {
  return {
    root: {
      '@media print': {
        display: 'none'
      }
    },
    fixedHeader: {
      position: 'sticky',
      top: '0px',
      zIndex: 100
    },
    fixedLeft: {
      position: 'sticky',
      left: '0px',
      zIndex: 100
    },
    icon: {
      cursor: 'pointer',
      transition: 'transform 0.25s'
    },
    expanded: {
      transform: 'rotate(90deg)'
    },
    hide: {
      visibility: 'hidden'
    },
    headerCell: {
      zIndex: 110,
      backgroundColor: theme.palette.background.paper
    },
    expandDisabled: {},
    checkboxRoot: {},
    checked: {},
    disabled: {}
  };
};
var TableSelectCell = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableSelectCell, _react$default$Compon);
  function TableSelectCell() {
    _classCallCheck(this, TableSelectCell);
    return _possibleConstructorReturn(this, _getPrototypeOf(TableSelectCell).apply(this, arguments));
  }
  _createClass(TableSelectCell, [{
    key: "render",
    value: function render() {
      var _ref, _ref3, _ref4;
      var _this$props = this.props,
        classes = _this$props.classes,
        fixedHeader = _this$props.fixedHeader,
        fixedSelectColumn = _this$props.fixedSelectColumn,
        isHeaderCell = _this$props.isHeaderCell,
        expandableOn = _this$props.expandableOn,
        selectableOn = _this$props.selectableOn,
        isRowExpanded = _this$props.isRowExpanded,
        onExpand = _this$props.onExpand,
        isRowSelectable = _this$props.isRowSelectable,
        selectableRowsHeader = _this$props.selectableRowsHeader,
        hideExpandButton = _this$props.hideExpandButton,
        expandableRowsHeader = _this$props.expandableRowsHeader,
        expandedRows = _this$props.expandedRows,
        _this$props$areAllRow = _this$props.areAllRowsExpanded,
        areAllRowsExpanded = _this$props$areAllRow === void 0 ? function () {
          return false;
        } : _this$props$areAllRow,
        selectableRowsHideCheckboxes = _this$props.selectableRowsHideCheckboxes,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var fixedHeaderClasses;
      if (!expandableOn && selectableOn === 'none') return false;
      var cellClass = (0, _classnames.default)((_ref = {}, _defineProperty2(_ref, classes.root, true), _defineProperty2(_ref, classes.fixedHeader, fixedHeader && isHeaderCell), _defineProperty2(_ref, classes.fixedLeft, fixedSelectColumn), _defineProperty2(_ref, classes.headerCell, isHeaderCell), _ref));
      var buttonClass = (0, _classnames.default)(_defineProperty2({}, classes.expandDisabled, hideExpandButton));
      var iconClass = (0, _classnames.default)((_ref3 = {}, _defineProperty2(_ref3, classes.icon, true), _defineProperty2(_ref3, classes.hide, isHeaderCell && !expandableRowsHeader), _defineProperty2(_ref3, classes.expanded, isRowExpanded || isHeaderCell && areAllRowsExpanded()), _ref3));
      var iconIndeterminateClass = (0, _classnames.default)((_ref4 = {}, _defineProperty2(_ref4, classes.icon, true), _defineProperty2(_ref4, classes.hide, isHeaderCell && !expandableRowsHeader), _ref4));
      var renderCheckBox = function renderCheckBox() {
        if (isHeaderCell && (selectableOn !== 'multiple' || selectableRowsHeader === false)) {
          // only display the header checkbox for multiple selection.
          return null;
        }
        return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
          classes: {
            root: classes.checkboxRoot,
            checked: classes.checked,
            disabled: classes.disabled
          },
          color: "primary",
          disabled: !isRowSelectable
        }, otherProps));
      };
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: cellClass,
        padding: "checkbox"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, expandableOn && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isHeaderCell && !areAllRowsExpanded() && expandedRows && expandedRows.data.length > 0 ? /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        onClick: onExpand,
        style: {
          padding: 0
        },
        disabled: expandableRowsHeader === false,
        className: buttonClass
      }, /*#__PURE__*/_react.default.createElement(_Remove.default, {
        id: "expandable-button",
        className: iconIndeterminateClass
      })) : /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        onClick: onExpand,
        style: {
          padding: 0
        },
        disabled: expandableRowsHeader === false,
        className: buttonClass
      }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, {
        id: "expandable-button",
        className: iconClass
      }))), selectableOn !== 'none' && selectableRowsHideCheckboxes !== true && renderCheckBox()));
    }
  }]);
  return TableSelectCell;
}(_react.default.Component);
_defineProperty(TableSelectCell, "propTypes", {
  /** Select cell checked on/off */
  checked: _propTypes.default.bool.isRequired,
  /** Select cell part of fixed header */
  fixedHeader: _propTypes.default.bool,
  /** Callback to trigger cell update */
  onChange: _propTypes.default.func,
  /** Extend the style applied to components */
  classes: _propTypes.default.object,
  /** Is expandable option enabled */
  expandableOn: _propTypes.default.bool,
  /** Adds extra class, `expandDisabled` when the row is not expandable. */
  hideExpandButton: _propTypes.default.bool,
  /** Is selectable option enabled */
  selectableOn: _propTypes.default.string
  /** Select cell disabled on/off */
});

_defineProperty(TableSelectCell, "defaultProps", {
  isHeaderCell: false,
  isRowExpanded: false,
  expandableOn: false,
  selectableOn: 'none'
});
var _default = (0, _styles.withStyles)(defaultSelectCellStyles, {
  name: 'MUIDataTableSelectCell'
})(TableSelectCell);
exports.default = _default;